<template>
  <div>
    <searchBar
      :search-form="searchForm"
      name
      status
      mobile
      @handleSearch="getData"
    ></searchBar>
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="60">
        <template slot-scope="scope">
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "account",
  data() {
    return {
      totalElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      searchForm: {
        name: "",
        status: "",
        mobile: "",
        // idCard: "",
      },
      tableHeader: {
        nickName: "微信昵称",
        name: "姓名",
        genderName: "性别",
        mobile: "电话",
        // idCard: "身份证号",
        loginTimes: "登录次数",
        lastLoginTime: "上次登录时间",
        statusName: "账号状态",
      },
      tableData: [
        {
          username: "222",
          mobile: "233",
        },
      ],
    }
  },
  methods: {
    /*提交搜索*/

    getData() {
      this.request({
        url: "/manager/account/findAccount",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          name: this.searchForm.name,
          status: this.searchForm.status,
          mobile: this.searchForm.mobile,
          idCard: this.searchForm.idCard,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/account/changeStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped lang="scss"></style>
